import { Component, OnInit, ViewChild,Output, EventEmitter} from '@angular/core';
import { PmdModal  } from '../propeller/modal/index';


@Component({
  selector: 'app-confirmation-popup',
  templateUrl: './confirmation-popup.component.html',
})
export class ConfirmationPopupComponent implements OnInit {
  @ViewChild('redirectionConfirmationPopup') redirectionConfirmationPopupTemplateRef: PmdModal;

  @Output() confirmed = new EventEmitter<boolean>();
  constructor() {}

  ngOnInit(): void {
  }

  /**
   * show confirmation popup
   */
  showConfirmationModal(){
    this.redirectionConfirmationPopupTemplateRef.show();
  }

  /**
   * hide confirmation popup
   */
  hideConfirmationModal(discardFlag=0){
    if(discardFlag == 1){
      this.confirmed.emit(true);
    }else{
      this.confirmed.emit(false);
    }
  }
}
